import storageUrl from '@/consts/api'

const utils = {
  getImagePath (productImgPath) {
    return `${storageUrl}${productImgPath}`
  }
}

export default utils
